import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { VENDORS } from "./apiRoutes";

const mutateAddVendor = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${VENDORS}`, data);
};

const useAddVendorMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddVendor,
    ...queryParams,
  });

export default useAddVendorMutation;
